import { LoginApiRequest } from '@/data/payload/api/AuthRequest'
import { LoginRequestInterface } from '@/data/payload/contracts/AuthRequest'
import ApiService from '@/app/framework/services/ApiServices'
import { AuthDataMapper } from '@/data/persistences/mappers/AuthDataMapper'
import { AuthRepositoryInterface } from '@/data/persistences/repositories/contracts/AuthRepositoryInterface'
import { Admin } from '@/domain/entities/Admin'
import { Endpoints } from '@/app/framework/misc/Endpoints'

export class AuthApiRepository implements AuthRepositoryInterface {
  private service: ApiService
  private mapper: AuthDataMapper

  constructor(service: ApiService, mapper: AuthDataMapper) {
    this.service = service
    this.mapper = mapper
  }

  public async login(payload: LoginRequestInterface): Promise<Admin> {
    const resp = await this.service.invoke(
      'post',
      Endpoints.Route.ADMIN_LOGIN,
      undefined,
      payload as LoginApiRequest
    )
    return this.mapper.convertAuthFromApi(resp.data)
  }
}
